import { Component, OnInit } from '@angular/core';
import { OfferService } from 'app/services/offer.service';
import { AuthService } from 'app/services/auth.service';
import { Router } from '@angular/router';
import { NgxCarousel } from 'ngx-carousel';
import { InstallationcostService } from 'app/services/installationcost.service';
import { Oferent } from 'app/model/oferent';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.css']
})
export class OffersComponent implements OnInit {

  public carouselOffers: NgxCarousel;
  isSU = false;
  isAdmin = false;

  constructor(
    public installationCostService: InstallationcostService,
    private router: Router,
    public offerService: OfferService,
    private authService: AuthService) { }

  ngOnInit() {
    this.isSU = this.authService.isSuperUser();
    this.carouselOffers = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: false,
      custom: 'banner'
    }
  }

  getIsHK(): boolean {
    return isHK;
  }

  showOfrs() {
    return this.offerService.getOffers().length > 0;
  }

  getOffers(): Oferent[] {
    return this.offerService.getOffers4CurrentLocation();
  }

  edit(id: string): void {
    this.router.navigate(['/offers']);
    this.router.navigate(['/offers/' + id]);
  }

  delete(id: string): void {
    this.offerService.delete(id);
  }

  confirm(id: string, val) {
    this.offerService.confirm(id, val);
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/offers/offers.component.ts